/**
 * Détermine la route « détail » d'un résultat de recherche globale,
 * selon son type de ressource.
 *
 * Renvoie `null` si le module concerné ne possède pas (encore) de vue
 * détail dédiée — l'appelant retombe alors sur la page de résultats.
 *
 * Pour étendre le deep-link à une nouvelle ressource : ajouter un cas
 * ici ET faire lire le paramètre `?focus=` par la page cible (cf.
 * PackagesRegistration.vue).
 */
export function searchResultRoute(
	type: string,
	item: any,
): { name: string; query: Record<string, any> } | null {
	switch (type) {
		case "package":
			// PackagesRegistration ouvre son panneau détail quand l'URL
			// porte ?focus=<référence du colis>.
			return {
				name: "workspace-operations-package-registration",
				query: { focus: item?.title },
			};
		default:
			// Billets, clients, agences : pas encore de vue détail dédiée.
			return null;
	}
}

export default searchResultRoute;
